import { Injectable, SimpleChange } from '@angular/core';
import { ModalService } from '../../../../shared/design-system/organisms/p-modal/p-modal.service';
import { Address } from '../../../models/address.model';
import { AddressTypeEnum } from '../../../../shared/models/address-type.enum';

@Injectable({
  providedIn: 'root',
})
export class AddressDomainService {
  constructor(private readonly modalService: ModalService) {}

  /**
   * permet le chargement de la popup lorsqu'on arrive la premiere fois sur le rapport
   * @param reportIdChange
   * @param addressAccuracyLevel
   * @param titleSection
   */
  loadPopupOnFirstReportLoading(
    reportIdChange: SimpleChange,
    titleSection: string,
    addressType: string,
  ) {
    // eslint-disable-next-line no-constant-condition
    if (
      reportIdChange.firstChange &&
      Object.values(AddressTypeEnum).includes(addressType as AddressTypeEnum)
    ) {
      this.modalService.showModal(`${titleSection.replace(/\s+/g, '_')}_id`);
    }
  }

  getAddressFromLabel(
    label: string,
    addressInputAutoCompletion: Address[],
  ): Address {
    return addressInputAutoCompletion
      .filter((address: Address) => address.label === label)
      .pop()!;
  }
}
